import React from "react";
import { Tree } from "react-d3-tree";

function transformData(data) {
  const treeData = [];
  const nodeMap = new Map();

  data.forEach((item) => {
    const { id, parentDesignationId, description } = item;
    const node = {
      name: description,
      children: [],
    };

    nodeMap.set(id, node);

    if (parentDesignationId) {
      const parentNode = nodeMap.get(parentDesignationId);
      if (parentNode) {
        parentNode.children.push(node);
      }
    } else {
      treeData.push(node);
    }
  });

  return treeData;
}

const TreeChart = ({ data }) => {
  const treeData = transformData(data);

  return (
    <div id="treeWrapper" style={{ width: "100%", height: "700px" }}>
      {treeData.length > 0 && (
        <Tree
          data={treeData}
          translate={{ x: 450, y: 50 }}
          orientation="vertical"
          collapsible={false}
          pathFunc="step"
          zoomable={false}
          separation={{ siblings: 2, nonSiblings: 1 }}
        />
      )}
    </div>
  );
};

export default TreeChart;
